/**
 * Routes authenticated users to nickname setup when /api/me says onboarding is
 * required. AuthContext is the single owner of the profile request.
 */

import { useAuth } from "@/contexts/AuthContext";
import { rememberPostLoginPath } from "@/lib/auth-navigation";
import { useEffect, useRef } from "react";
import { useLocation } from "wouter";

export function FirstLoginNicknameCheck() {
  const {
    user,
    userProfile,
    isAuthenticated,
    loading: authLoading,
  } = useAuth();
  const [, setLocation] = useLocation();
  const checkedUidRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      checkedUidRef.current = null;
      return;
    }

    if (authLoading || !userProfile || checkedUidRef.current === user.uid) {
      return;
    }

    if (window.location.pathname === "/nickname/setup") {
      return;
    }

    // undefined means /api/me was unavailable and AuthContext is using its
    // Firebase-only fallback. Do not trap a user in onboarding on an outage.
    if (userProfile.nicknameRequired === undefined) {
      checkedUidRef.current = user.uid;
      return;
    }

    checkedUidRef.current = user.uid;
    if (userProfile.nicknameRequired) {
      rememberPostLoginPath();
      setLocation("/nickname/setup");
    }
  }, [
    authLoading,
    isAuthenticated,
    setLocation,
    user,
    userProfile,
  ]);

  return null;
}
